import { ReduxSimpleActionInterface } from '@ecommerce/nest-ssr';
import { ReviewCommentInterface } from 'modules/review/review.interface';
import { ProductReviewInterface } from 'interfaces/product-review.interface';
import { ApiListInterface } from 'interfaces/api.interface';

export enum ProductReviewsActions {
    AddComment = 'ADD_COMMENT'
}

export const productReviews = [
    (
        state: ApiListInterface<ProductReviewInterface>,
        action: ReduxSimpleActionInterface<ProductReviewsActions.AddComment, { payload: { comment: ReviewCommentInterface; productReviewId: number; }; }>
    ): ApiListInterface<ProductReviewInterface> => {
        switch (action.type) {
            case ProductReviewsActions.AddComment:
                // eslint-disable-next-line no-case-declarations
                const items = state.items.map(review => {
                    if (Number(review.id) === Number(action.payload.productReviewId)) {
                        review.userComment = [
                            action.payload.comment,
                            ...(review.userComment || [])
                        ];
                    }

                    return review;
                });

                return {
                    ...state,
                    items
                };
            default:
                return state;
        }
    }
];
